export default "__VITE_ASSET__BskQbS80__"